<template>
  <div class="d-flex fd-column jc-between">
    <portal to="MODAL">
      <view-review-modal
          :review="modalData"
          @close="next"/>
    </portal>
  </div>
</template>

<script>
import ViewReviewModal from './components/ViewReviewModal';

export default {
  name: 'review-modal',
  components: {
    ViewReviewModal,
  },
  props: {
    modalData: {
      type: Object,
      required: true,
    },

  },
  methods: {
    next (payload) {
      this.$emit('next', payload);
    },
  },
};
</script>
